export default __webpack_public_path__ + "static/media/spaces_openapi.c28a1697.yaml";